import {
  checkDevice,
  setDisplay,
  setModalMessage,
  showToast,
  openCommonModal,
  disableButton,
  closeModal,
  closeMyModal,
  getCookie,
  setCookie,
  reformatPaste,
} from "./common";

var userProfile;
var trans;
var currentUserId;
var ui;
var newUser;
var authListener;
var email;
var registerUser;

$(document).ready(function () {
  $(function () {
    initViews();
    translatePage();
    initClickListeners();
    reformatPaste();
    userProfile = {
      userId: null,
      email: null,
      profile_Image: null,
      name: null,
      lowCaseName: null,
      isCreator: true,
      date_created: null,
    };
    getUser();
    window.onclick = function (event) {
      if (!event.target.matches(".dropbtn")) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      }
    };
    checkDevice();
  });
});

function initViews() {
  registerUser = document.getElementById("registerUser");
}
function initClickListeners() {
  btnTranslate.addEventListener("click", function () {
    showDropdown();
  });
  aEn.addEventListener("click", function () {
    translatePage("en");
  });
  aEs.addEventListener("click", function () {
    translatePage("es");
  });

  downloadApp.querySelector(".close").addEventListener("click", function () {
    closeModal("downloadApp");
  });
  registerModal
    .querySelector(".img-thumbnail")
    .addEventListener("click", function () {
      uploadImage("register");
    });
  myModal.querySelector(".close").addEventListener("click", function () {
    closeMyModal();
  });
  myModal.querySelector(".btnBlue").addEventListener("click", function () {
    closeMyModal();
  });
  fufuf.addEventListener("click", function () {
    uploadImage("banner");
  });
  upLogo.addEventListener("click", function () {
    uploadImage("logo");
  });
  inRadioStream.addEventListener("input", function () {
    editAudio.innerHTML = "";
    var radioUrl = inRadioStream.value.trim();
    var source = document.createElement("source"); //document.getElementById('radioStream');
    source.src = radioUrl;
    editAudio.appendChild(source);
    var backupSource = document.createElement("source");
    var backUpUrl;
    if (radioUrl.endsWith("/")) {
      backUpUrl = radioUrl + ";";
    } else if (radioUrl.endsWith("/;")) {
      //backupSource.src = radioStream;
      backUpUrl = radioUrl;
    } else {
      //backupSource.src = radioStream + "/;";
      backUpUrl = inRadioStream.value.trim() + "/;";
    }

    backupSource.src = backUpUrl;
    editAudio.appendChild(backupSource);
    editAudio.load();
    var note = registerRadio.querySelector(".notes.redText");
    note.style.display = radioUrl.includes("https") ? "none" : "block";
    aRadioLink.href = radioUrl;
  });
}

function showDropdown() {
  document.getElementById("langDropdown").classList.toggle("show");
}
function getUser() {
  authListener = firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      currentUserId = firebase.auth().currentUser.uid;
      if (firebase.auth().currentUser.email) {
        email = firebase.auth().currentUser.email;
      } else {
        email = firebase.auth().currentUser.phoneNumber;
      }
      getProfileInfo();
      startRadioForm();
    } else {
      //authListener();
      setDisplay(registerRadio, "none");
      setDisplay(registerUser, "flex");
      btnEmailLogin.addEventListener(
        "click",
        function () {
          setDisplay(emailOptions, "block");
          setDisplay(phoneOptions, "none");
        },
        false
      );

      btnPhoneLogin.addEventListener(
        "click",
        function () {
          initPhoneOption();
          setDisplay(emailOptions, "none");
          setDisplay(phoneOptions, "block");
        },
        false
      );

      btnNext.addEventListener(
        "click",
        function () {
          if (etEmail.value && etEmail.value.includes("@")) {
            setDisplay(loading, "block");
            setDisplay(btnNext, "none");
            setDisplay(etPassword, "block");
            setDisplay(btnLogin, "block");
            checkEmail(etEmail.value);
          } else {
            showToast(trans.errorEmail);
            setDisplay(loading, "none");
          }
        },
        false
      );

      btnLogin.addEventListener(
        "click",
        function () {
          if (!etPassword.value) {
            showToast(trans.errorPass);
            return;
          }
          if (newUser) {
            createUserEmailPass(etEmail.value, etPassword.value);
          } else {
            loginUserEmailPass(etEmail.value, etPassword.value);
          }
        },
        false
      );
    }
  });
}

function startRadioForm() {
  var bannerFile, logoFile;
  inBannerUpload.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      bannerFile = this.files[0];
      imgBanner.src = URL.createObjectURL(bannerFile); // set src to blob url
      setDisplay(imgBanner, "block");
    } else {
      bannerFile = null;
      setDisplay(imgBanner, "none");
    }
  });

  inLogoUpload.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      logoFile = this.files[0];
      imgLogo.src = URL.createObjectURL(logoFile); // set src to blob url
      setDisplay(imgLogo, "block");
    } else {
      logoFile = null;
      setDisplay(imgLogo, "none");
    }
  });

  btnAddRadio.addEventListener(
    "click",
    function () {
      if (
        checkInput(
          inLogoUpload.files[0],
          inAdminName.value.trim(),
          inRadioName.value.trim(),
          inDescription.value.trim(),
          inRadioStream.value.trim(),
          inPassword.value.trim(),
          countries.value,
          inRadioEmail.value.trim()
        )
      ) {
        disableButton(btnAddRadio, true);
        loadingRadioRegister.querySelector("p").textContent =
          trans.radioRegister;
        setDisplay(loadingRadioRegister, "block");
        checkStream(inRadioStream.value.trim(), bannerFile, logoFile);
      }
    },
    false
  );
}

function checkStream(radioStream, bannerFile, logoFile) {
  var radiosRef = firebase.database().ref("Radio Stations");
  radiosRef
    .orderByChild("info/radio_Stream")
    .equalTo(radioStream)
    .once("value", function (snapshot) {
      if (snapshot.exists()) {
        disableButton(btnAddRadio, false);
        setDisplay(loadingRadioRegister, "none");
        setModalMessage(trans.errorStreamCopy);
        openCommonModal();
      } else {
        //check name exists
        checkRadioName(radioStream, bannerFile, logoFile);
        //createRadio(radioStream, radiosRef, bannerFile, logoFile);
      }
    });
}

function checkRadioName(radioStream, bannerFile, logoFile) {
  var radiosRef = firebase.database().ref("Radio Stations");
  var radioName = inRadioName.value.trim();
  radiosRef
    .orderByChild("info/radio_Name")
    .equalTo(radioName)
    .once("value", function (snapshot) {
      if (snapshot.exists()) {
        disableButton(btnAddRadio, false);
        setDisplay(loadingRadioRegister, "none");
        setModalMessage(trans.errorNameCopy);
        openCommonModal();
      } else {
        //check name exists
        createRadio(radioStream, radiosRef, bannerFile, logoFile);
      }
    });
}
function createRadio(radioStream, radiosRef, bannerFile, logoFile) {
  var radioId = radiosRef.push().key;
  if (radioId) {
    uploadLogo(radioId, bannerFile, logoFile, radioStream);
  } else {
    disableButton(btnAddRadio, false);
    setDisplay(loadingRadioRegister, "none");
    setModalMessage(trans.errorUnknown);
    openCommonModal();
  }
}

function uploadLogo(radioId, bannerFile, logoFile, radioStream) {
  //Upload logo
  var logoPath = "Radio Stations/" + radioId + "/Logo";
  var storageRef = firebase.storage().ref().child(logoPath);
  var uploadTask = storageRef.put(logoFile);
  uploadTask.on(
    "state_changed",
    function (snapshot) {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      if (progress) {
        loadingRadioRegister.querySelector("p").textContent =
          trans.uploadingLogo + progress + "%";
      }
      //console.log('Upload is ' + progress + '% done');
    },
    function (error) {
      var errorMess;
      switch (error.code) {
        case "storage/unauthorized":
          // User doesn't have permission to access the object
          errorMess = trans.errorImage;
          break;
        case "storage/canceled":
          errorMess = trans.errorUploadCancel;
          break;
        case "storage/unknown":
          // Unknown error occurred, inspect error.serverResponse
          errorMess = trans.errorUnknown;
          break;
      }
      disableButton(btnAddRadio, false);
      setDisplay(loadingRadioRegister, "none");
      setModalMessage(errorMess);
      openCommonModal();
    },
    function () {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        //console.log('File available at', downloadURL);
        //Upload banner if available
        if (bannerFile) {
          uploadBanner(radioId, downloadURL, bannerFile, radioStream);
        } else {
          uploadRadioInfo(radioId, downloadURL, null, radioStream);
        }
      });
    }
  );
}
function uploadBanner(radioId, logoUrl, bannerFile, radioStream) {
  //Upload banner
  var bannerPath = "Radio Stations/" + radioId + "/Banner";
  var storageRef = firebase.storage().ref().child(bannerPath);
  var uploadTask = storageRef.put(bannerFile);
  uploadTask.on(
    "state_changed",
    function (snapshot) {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      if (progress) {
        loadingRadioRegister.querySelector("p").textContent =
          trans.uploadingBanner + progress + "%";
      }
      //console.log('Upload is ' + progress + '% done');
    },
    function (error) {
      var errorMess;
      switch (error.code) {
        case "storage/unauthorized":
          // User doesn't have permission to access the object
          errorMess = trans.errorImage;
          break;
        case "storage/canceled":
          errorMess = trans.errorUploadCancel;
          break;
        case "storage/unknown":
          // Unknown error occurred, inspect error.serverResponse
          errorMess = trans.errorUnknown;
          break;
      }
      disableButton(btnAddRadio, false);
      setDisplay(loadingRadioRegister, "none");
      setModalMessage(errorMess);
      openCommonModal();
    },
    function () {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        //console.log('File available at', downloadURL);
        uploadRadioInfo(radioId, logoUrl, downloadURL, radioStream);
      });
    }
  );
}
function uploadRadioInfo(radioId, logoUrl, bannerUrl, radioStream) {
  var radName = inRadioName.value.trim();
  loadingRadioRegister.querySelector("p").textContent =
    trans.uploadingRadioInfo;
  var time = new Date().getTime();
  var radioInfo = {
    radio_Name: radName,
    radio_Slogan: null,
    radio_image: logoUrl,
    banner: null,
    date_created: time,
    radio_ID: radioId,
    verified: false,
  };

  var newRadio = {
    admin_ID: currentUserId,
    admin_Name: inAdminName.value.trim(),
    lowCaseName: radName.toLowerCase(),
    admin_Pass: inPassword.value.trim(),
    radio_Name: radName,
    radio_Description: inDescription.value.trim(),
    radio_Stream: radioStream,
    radio_location: countries.options[countries.selectedIndex].textContent,
    radio_Slogan: null,
    phone_no: null,
    radio_email: null,
    website: null,
    radio_image: logoUrl,
    banner: null,
    date_created: time,
  };

  if (bannerUrl) {
    radioInfo.banner = bannerUrl;
    newRadio.banner = bannerUrl;
  }

  if (inSlogan.value.trim()) {
    radioInfo.radio_Slogan = inSlogan.value.trim();
    newRadio.radio_Slogan = inSlogan.value.trim();
  }

  if (inPhone.value.trim()) {
    newRadio.phone_no = inPhone.value.trim();
  }

  if (inRadioEmail.value.trim()) {
    newRadio.radio_email = inRadioEmail.value.trim();
  }
  if (inWebsite.value.trim()) {
    newRadio.website = inWebsite.value.trim();
  }

  //Upload to verify radio
  var radiosRef = firebase.database().ref("verify/radio/" + radioId + "/info");
  radiosRef.set(newRadio, function (error) {
    if (error) {
      //message failed
      disableButton(btnAddRadio, false);
      setDisplay(loadingRadioRegister, "none");
      setModalMessage(trans.errorUnknown);
      openCommonModal();
    } else {
      //Upload radioInfo
      loadingRadioRegister.querySelector("p").textContent = trans.radioRegister;
      var userRadiosRef = firebase
        .database()
        .ref("Users/" + currentUserId + "/My_Radios/" + radioId);
      userRadiosRef.set(radioInfo, function (error) {
        if (error) {
          //message failed
          disableButton(btnAddRadio, false);
          setDisplay(loadingRadioRegister, "none");
          setModalMessage(trans.errorUnknown);
          openCommonModal();
        } else {
          //Upload userProfile
          loadingRadioRegister.querySelector("p").textContent =
            trans.uploadingRadioInfo;
          userProfile.date_created = time;
          var adminRadioRef = firebase
            .database()
            .ref(
              "verify/radio/" + radioId + "/Administrators/" + currentUserId
            );
          adminRadioRef.set(userProfile, function (error) {
            if (error) {
              //message failed
              disableButton(btnAddRadio, false);
              setDisplay(loadingRadioRegister, "none");
              setModalMessage(trans.errorUnknown);
              openCommonModal();
            } else {
              //show completion message
              disableButton(btnAddRadio, false);
              setDisplay(loadingRadioRegister, "none");
              //registerRadio.querySelector('form').reset();
              modRegSuccess.querySelector("h2").textContent = trans.congrats;
              modRegSuccess.querySelector("p").innerHTML =
                trans.msgRadioVerify.replace("$name", radName);
              // var rad = radName.replace(/--/g, "_");
              // rad = rad.replace(/\s+/g, "-");
              // rad = rad.replace(/_/g,"--");
              var urlExt =
                modRegSuccess.querySelector("a").href + "$v=" + radioId;
              modRegSuccess.querySelector("a").href = urlExt;
              modRegSuccess.querySelector("a").textContent = urlExt;
              btnContinue.addEventListener(
                "click",
                function () {
                  goToRadioWeb(urlExt);
                },
                false
              );
              setDisplay(modRegSuccess, "flex");
            }
          });
        }
      });
    }
  });

  //Upload to Radio Stations
  // var radiosRef = firebase.database().ref("Radio Stations/" + radioId + "/info");
  // radiosRef.set(newRadio,
  // function(error){
  //     if(error)
  //     {
  //         //message failed
  //         disableButton(btnAddRadio, false);
  //         setDisplay(loadingRadioRegister,"none");
  //         setModalMessage(trans.errorUnknown);
  //         openCommonModal();
  //     }
  //     else{
  //         //Upload radioInfo
  //         loadingRadioRegister.querySelector('p').textContent = trans.radioRegister;
  //         var userRadiosRef = firebase.database().ref("Users/"+ currentUserId + "/My_Radios/" + radioId);
  //         userRadiosRef.set(radioInfo,
  //         function(error){
  //             if(error)
  //             {
  //                 //message failed
  //                 disableButton(btnAddRadio, false);
  //                 setDisplay(loadingRadioRegister,"none");
  //                 setModalMessage(trans.errorUnknown);
  //                 openCommonModal();
  //             }
  //             else{
  //                 //Upload userProfile
  //                 loadingRadioRegister.querySelector('p').textContent = trans.uploadingRadioInfo;
  //                 userProfile.date_created = time;
  //                 var adminRadioRef = firebase.database().ref("Radio Stations/"+ radioId + "/Administrators/" + currentUserId);
  //                 adminRadioRef.set(userProfile,
  //                 function(error){
  //                     if(error)
  //                     {
  //                         //message failed
  //                         disableButton(btnAddRadio, false);
  //                         setDisplay(loadingRadioRegister,"none");
  //                         setModalMessage(trans.errorUnknown);
  //                         openCommonModal();
  //                     }
  //                     else{
  //                         //show completion message
  //                         disableButton(btnAddRadio, false);
  //                         setDisplay(loadingRadioRegister,"none");
  //                         //registerRadio.querySelector('form').reset();
  //                         modRegSuccess.querySelector('h2').textContent = trans.congrats;
  //                         modRegSuccess.querySelector('p').innerHTML = trans.radioMessage;
  //                         var rad = radName.replace(/--/g, "_");
  //                         rad = rad.replace(/\s+/g, "-");
  //                         rad = rad.replace(/_/g,"--");
  //                         var urlExt = modRegSuccess.querySelector('a').href + rad;//radName.replace(/--/g, "_").replace(/\s+/g, "-").replace(/_/g,"--");
  //                         modRegSuccess.querySelector('a').href =  urlExt;
  //                         modRegSuccess.querySelector('a').textContent = urlExt;
  //                         btnContinue.addEventListener('click', function(){
  //                             goToRadioWeb(urlExt);
  //                         },false);
  //                         setDisplay(modRegSuccess,"flex");
  //                     }
  //                 });
  //             }
  //         });
  //     }
  // });
}

function goToRadioWeb(radioUrl) {
  window.location.replace(radioUrl);
}

function checkInput(
  logo,
  adminName,
  radioName,
  radioDesc,
  radioUrl,
  adminPass,
  radioLocation,
  radioEmail
) {
  if (!logo) {
    showToast(trans.errorLogo);
    var topOfElement = document.querySelector("#upLogo").offsetTop - 62;
    window.scroll({ top: topOfElement, behavior: "smooth" });
    $(upLogo).shake();
    return false;
  } else if (!adminName) {
    showToast(trans.errorName);
    var topOfElement = document.querySelector("#inAdminName").offsetTop - 62;
    window.scroll({ top: topOfElement, behavior: "smooth" });
    $(inAdminName).shake();
    return false;
  } else if (!radioName) {
    showToast(trans.errorRadioName);
    //inRadioName.scrollIntoView();
    var topOfElement = document.querySelector("#inRadioName").offsetTop - 62;
    window.scroll({ top: topOfElement, behavior: "smooth" });
    $(inRadioName).shake();
    return false;
  } else if (!radioEmail || !radioEmail.includes("@")) {
    showToast(trans.errorEmail);
    var topOfElement = document.querySelector("#inRadioEmail").offsetTop - 62;
    window.scroll({ top: topOfElement, behavior: "smooth" });
    $(inRadioEmail).shake();
    return false;
  } else if (!radioUrl || !inRadioStream.checkValidity()) {
    showToast(trans.errorRadioUrl);
    var topOfElement = document.querySelector("#inRadioStream").offsetTop - 62;
    window.scroll({ top: topOfElement, behavior: "smooth" });
    $(inRadioStream).shake();
    return false;
  } else if (!adminPass) {
    showToast(trans.errorAdminpass);
    var topOfElement = document.querySelector("#inPassword").offsetTop - 62;
    window.scroll({ top: topOfElement, behavior: "smooth" });
    $(inPassword).shake();
    return false;
  } else if (!radioDesc) {
    showToast(trans.errorDescription);
    var topOfElement = document.querySelector("#inDescription").offsetTop - 62;
    window.scroll({ top: topOfElement, behavior: "smooth" });
    $(inDescription).shake();
    return false;
  } else if (!radioLocation) {
    showToast(trans.errorLocation);
    var topOfElement = document.querySelector("#countries").offsetTop - 62;
    window.scroll({ top: topOfElement, behavior: "smooth" });
    $(countries).shake();
    return false;
  } else {
    return true;
  }
}

function createUserEmailPass(email, pass) {
  setDisplay(loading, "block");
  firebase
    .auth()
    .createUserWithEmailAndPassword(email, pass)
    .then(function (user) {
      if (user) {
        currentUserId = firebase.auth().currentUser.uid;
        email = firebase.auth().currentUser.email;
        setDisplay(registerRadio, "block");
        setDisplay(registerUser, "none");
        setDisplay(loading, "none");
        //getProfileInfo();
      } else {
        showToast(trans.errorRegister);
        setDisplay(loading, "none");
      }
    })
    .catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      showToast(errorMessage);
      setDisplay(loading, "none");
    });
}

function loginUserEmailPass(email, pass) {
  setDisplay(loading, "block");
  firebase
    .auth()
    .signInWithEmailAndPassword(email, pass)
    .then(function () {
      currentUserId = firebase.auth().currentUser.uid;
      email = firebase.auth().currentUser.email;
      setDisplay(registerRadio, "block");
      setDisplay(registerUser, "none");
      setDisplay(loading, "none");
      //getProfileInfo();
    })
    .catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;

      showToast(errorCode + ": " + errorMessage);
      setDisplay(loading, "none");
      //window.alert('Error ' + errorCode + ": " + errorMessage);
    });
}

function getProfileInfo() {
  var userRef = firebase.database().ref("Users/" + currentUserId + "/info");
  userRef.once("value").then(function (snapshot) {
    if (snapshot.val()) {
      var userInfo = snapshot.val();
      userProfile.email = userInfo.email;
      userProfile.name = userInfo.name;
      userProfile.lowCaseName = userInfo.name.toLowerCase();
      if (userInfo.djImage) {
        userProfile.profile_Image = userInfo.djImage;
      } else if (userInfo.profile_Image) {
        userProfile.profile_Image = userInfo.profile_Image;
      }
      inAdminName.value = userProfile.name;
      setDisplay(registerRadio, "block");
    } else {
      //authListener();
      //console.log("name does not exist");
      registerUserInfo();
    }
  });
}

function initPhoneOption() {
  if (!ui) {
    ui = new firebaseui.auth.AuthUI(firebase.auth());

    var uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function (authResult, redirectUrl) {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          currentUserId = firebase.auth().currentUser.uid;
          email = firebase.auth().currentUser.phoneNumber;
          //setDisplay(newUserModal, "none");
          //setDisplay(loader, "none");
          //setDisplay(petitionBox,"block");
          //setDisplay(newUserBox,"none");
          setDisplay(loading, "none");
          showToast("Welcome!");
          setDisplay(registerRadio, "block");
          setDisplay(registerUser, "none");
          //getCurrentUserId();
          //getProfileInfo();

          return false;
        },
        signInFailure: function (error) {
          // Some unrecoverable error occurred during sign-in.
          // Return a promise when error handling is completed and FirebaseUI
          // will reset, clearing any UI. This commonly occurs for error code
          // 'firebaseui/anonymous-upgrade-merge-conflict' when merge conflict
          // occurs. Check below for more details on this.
          setDisplay(loading, "none");
          showToast(error);
          return handleUIError(error);
        },
        uiShown: function () {
          // The widget is rendered.
          // Hide the loader.
          setDisplay(loading, "none");
        },
      },
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          recaptchaParameters: {
            type: "image", // 'audio'
            size: "normal", // 'invisible' or 'compact'
            badge: "bottomleft", //' bottomright' or 'inline' applies to invisible.
          },
          //loginHint: '+11234567890'
        },
      ],
      // Terms of service url.
      tosUrl: "https://chatmurcianys.com/about#terms",
      // Privacy policy url.
      privacyPolicyUrl: "https://chatmurcianys.com/about#privacy",
    };

    ui.start(phoneOptions, uiConfig);
  }
}

function registerUserInfo() {
  var uploadFile;
  var registerModal = document.getElementById("registerModal");
  var imgUser = document.getElementById("imgUser");
  imgUser.src = "../images/person_placeholder.svg";
  var inName = document.getElementById("inName");
  var loader = document.getElementById("loadingInfo");
  $(document).ready(function () {
    inName.focus();
  });

  var btnRegister = document.getElementById("btnRegister");

  inImageUpload.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      uploadFile = this.files[0];
      //console.log("image file: " + inImageUpload.value);

      // $('img')[0]
      imgUser.src = URL.createObjectURL(uploadFile); // set src to blob url
    }
  });

  setDisplay(registerModal, "block");

  btnRegister.addEventListener(
    "click",
    function () {
      if (inName.value) {
        setDisplay(loader, "block");
        disableButton(btnRegister, true);
        var userName = inName.value;
        var time = new Date().getTime();
        var userInfo = {
          email: email,
          name: userName,
          lowCaseName: userName.toLowerCase(),
          profile_Image: null,
          name_change: "no",
          isPlaying: false,
          date_created: time,
        };
        if (uploadFile) {
          var filePath =
            "User Profile Images/" + currentUserId + "/Images/Profile Pic";
          var storageRef = firebase.storage().ref().child(filePath);
          var uploadTask = storageRef.put(uploadFile);
          uploadTask.on(
            "state_changed",
            function (snapshot) {},
            function (error) {
              switch (error.code) {
                case "storage/unauthorized":
                  // User doesn't have permission to access the object
                  showToast(trans.errorStoragePermission);
                  break;
                case "storage/canceled":
                  showToast(trans.errorUploadCanceled);
                  break;
                case "storage/unknown":
                  // Unknown error occurred, inspect error.serverResponse
                  showToast(trans.errorRegister);
                  break;
              }
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
            },
            function () {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  //console.log('File available at', downloadURL);
                  userInfo.profile_Image = downloadURL;
                  var userRef = firebase
                    .database()
                    .ref("Users/" + currentUserId + "/info");
                  userRef.set(userInfo, function (error) {
                    if (error) {
                      //message failed
                      showToast(trans.errorRegister);
                      setDisplay(loader, "none");
                      disableButton(btnRegister, false);
                    } else {
                      //message sent
                      //console.log("****uploaded user info***");

                      setDisplay(registerModal, "none");
                      setDisplay(loader, "none");
                      disableButton(btnRegister, false);
                      showToast(trans.thankRegister);
                      getProfileInfo();
                      setDisplay(registerRadio, "block");
                    }
                  });
                });
            }
          );
        } else {
          //console.log("id : " + currentChatId);

          var userRef = firebase
            .database()
            .ref("Users/" + currentUserId + "/info");
          userRef.set(userInfo, function (error) {
            if (error) {
              //message failed
              showToast(trans.errorRegister);
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
            } else {
              //message sent
              setDisplay(registerModal, "none");
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
              showToast(trans.thankRegister);
              getProfileInfo();
              setDisplay(registerRadio, "block");
            }
          });
        }
      } else {
        inName.focus();
        showToast(trans.errorProvideName);
      }
    },
    false
  );
}

function checkEmail(email) {
  firebase
    .auth()
    .fetchSignInMethodsForEmail(email)
    .then(function (signInMethods) {
      if (
        signInMethods.indexOf(
          firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
        ) != -1
      ) {
        setDisplay(divPassInfo, "block");
        divPassInfo.textContent = trans.welcomeBack;
        etPassword.placeholder = trans.password;
        newUser = false;
        // User can sign in with email/password.
      } else {
        setDisplay(divPassInfo, "block");
        divPassInfo.textContent = trans.createPass;
        etPassword.placeholder = trans.anyPass;
        newUser = true;
      }
      setDisplay(loading, "none");
    })
    .catch(function (error) {
      showToast(error);
      setDisplay(loading, "none");
      // Some error occurred, you can inspect the code: error.code
    });
}

function uploadImage(type) {
  switch (type) {
    case "register":
      inImageUpload.click();
      break;
    case "logo":
      inLogoUpload.click();
      break;
    case "banner":
      inBannerUpload.click();
      break;
  }
}

jQuery.fn.shake = function (intShakes, intDistance, intDuration) {
  intShakes = intShakes || 10;
  intDistance = intDistance || 2;
  intDuration = intDuration || 1000;

  this.each(function () {
    $(this).css("position", "relative");
    for (var x = 1; x <= intShakes; x++) {
      $(this)
        .animate({ left: intDistance * -1 }, intDuration / intShakes / 4)
        .animate({ left: intDistance }, intDuration / intShakes / 2)
        .animate({ left: 0 }, intDuration / intShakes / 4);
    }
  });
  return this;
};

var language = {
  eng: {
    title: "Add Radio",
    en: "En",
    register: "You need to be logged in to register your radio station.",
    continue: "Continue with...",
    phone: "Phone",
    email: "Email",
    password: "Password",
    rememberMe: "Remember me",
    login: "LOGIN",
    infoLog:
      "We will use the information above to log you in or to create a new account if you do not have one.",
    disclaimer:
      'By continuing, you agree to our <a href="about.html#terms">Terms and Conditions</a>, and <a href="about.html">Privacy policy</a>',
    fillInfo:
      'Fill out the information below. The fields marked with an "*" are required.',
    optionalInfo:
      "The following information is optional. How else can your audience connect with you? (Optional)",
    uploadBanner: "Upload banner",
    uploadLogo: "Upload logo *",
    adminName: "Admin name *",
    radioName: "Radio name *",
    slogan: "slogan",
    noteSlogan:
      '*Example: "The Best Variety of Yesterday and Today - Sunny 99.1"',
    radioStream: "Radio stream URL *",
    noteStream: '*Example: "https://xxxx:1232"',
    anyPass: "Any password *",
    notePass:
      "This should not be your stream password! Provide any password to keep your radio safe",
    description:
      "Describe your radio *...What kind of music does your radio play, broadcast hours, etc.",
    location: "Radio location: *",
    website: "Website address",
    country: "Select country",
    next: "Next",
    errorEmail: "Please provide a valid email address",
    welcomeBack: "Welcome back! Enter the password for this account",
    createPass: "Create a password to secure your account",
    creatingAcc: "Creating account. Please wait...",
    uploadImage: "Upload Image",
    whatName: "What name would you like to use?",
    registerMe: "Register",
    name: "Name",
    thankRegister: "Thank you for registering!",
    errorRegister: "Error registering. Try again later.",
    errorPass: "Please provide a password for your account.",
    errorName: "Pleade provide the radio's administrator's name",
    errorRadioName: "Please provide the radio's name",
    errorDescription: "Please provide a description for your radio",
    errorRadioUrl: "Please provide the stream url of the radio",
    errorAdminpass: "Please provide a password to secure your radio station",
    errorLocation: "Please tells us where your radio is located",
    errorLogo: "Please upload an image of the logo on your radio",
    radioRegister: "Registering radio. Please wait...",
    congrats: "Congratulations",
    radioMessage:
      "Your radio station is now part of ChatMurcianys.<br>A web page was created for you to share with your audience.",
    errorStreamCopy:
      "This radio stream already exists in our app. Please provide a different one.",
    uploadingLogo: "Uploading logo...",
    uploadingBanner: "Uploading banner...",
    errorUnknown: "Unknown error occurred. Try again later",
    uploadingRadioInfo: "Uploading radio information, please wait...",
    errorImage: "You don't have permission to upload this image",
    errorUploadCancel: "You canceled the upload",
    downloadMess:
      "ChatMurcianys is available for your device on the Google PlayStore",
    download: "Descargar",
    idiom: "En",
    urlCheck: "Can you hear the radio? If not, edit the stream above",
    audioError:
      '*Some browsers may not reproduce your audio because it does not start with "https" <a id="aRadioLink" href="" target="_blank">click here to test audio</a>',
    errorNameCopy:
      "This radio name already exists in our app. Please provide a different one.",
    msgRadioVerify:
      "Your application to add $name to ChatMurcianys has been received.<br>" +
      "We will notify you when your radio is registered and ready to share.<br>" +
      'In the meantime, you can check the status of you application by visiting "My radios" and make any changes if needed.',
    close: "Close",
    errorStoragePermission:
      "You don't have permission to upload this image. Upload a different image.",
    errorUploadCanceled: "The upload was canceled",
    errorProvideName: "Please provide your name",
  },
  es: {
    title: "Añadir Radio",
    en: "Es",
    register: "Necesitas entrar a tu cuenta para poder registrar tu radio",
    continue: "Continua con...",
    phone: "Teléfono",
    email: "Correo Electrónico",
    password: "Contraseña",
    rememberMe: "Recúerdame",
    login: "Iniciar Sesión",
    infoLog:
      "Utilizaremos la información anterior para iniciar sesión o para crear una nueva cuenta si no tiene una.",
    disclaimer:
      'Al continuar, aceptas nuestros <a href="about.html#terms">Términos y Condiciones</a>, y <a href="about.html">Política de Seguridad</a>',
    fillInfo:
      'Completa la información a continuación. Los campos marcados con un "*" son obligatorios.',
    optionalInfo:
      "La siguiente información es opcional. De que otra manera puede conectarse tu audiencia contigo? (Opcional)",
    uploadBanner: "Subir banner",
    uploadLogo: "Subir logo *",
    adminName: "Nombre del dueño de la radio *",
    radioName: "Nombre de la radio *",
    slogan: "slogan",
    noteSlogan: '*Ejemplo: "Música con buen gusto! - Amor 106.5"',
    radioStream: "URL de transmisión de la radio *",
    noteStream: '*Ejemplo: "https://xxxx:1232"',
    anyPass: "Cualquier contraseña *",
    notePass:
      "¡Esto no debería ser tu contraseña de transmisión! Proporciona cualquier contraseña para mantener tu radio segura",
    description:
      "Describe tu radio*...Qué tipo de música reproduce tu radio, horas de emisión, etc.",
    location: "Ubicación de la radio: *",
    website: "Dirección del sitio web",
    country: "Selecciona un pais",
    next: "Continuar",
    errorEmail: "Por favor provee un correo electrónico valido",
    welcomeBack: "¡Bienvenido de nuevo! Ingrese la contraseña para esta cuenta",
    createPass: "Crea una contraseña para proteger tu cuenta",
    creatingAcc: "Creando la cuenta. Por favor espere...",
    uploadImage: "Subir Imagen",
    whatName: "¿Que nombre te gustaria usar?",
    registerMe: "Registrarme",
    name: "Nombre",
    thankRegister: "¡Gracias por registrarte!",
    errorRegister: "Error registrandote. Inténtalo de nuevo más tarde.",
    errorPass: "Por favor, proporciona una contraseña para tu cuenta.",
    errorName: "Por favor, indica el nombre del administrador de la radio",
    errorRadioName: "Por favor, indica el nombre de la radio",
    errorDescription: "Por favor, describe tu radio",
    errorRadioUrl: "Por favor, indica el URL de la transmisión de radio",
    errorAdminpass:
      "Por favor, indica una contraseña para proteger tu estación de radio",
    errorLocation: "Por favor dinos dónde se encuentra tu radio",
    errorLogo: "Por favor sube una imagen del logo de tu radio",
    radioRegister: "Registrando la radio. Por favor espere ...",
    congrats: "¡Felicidades!",
    radioMessage:
      "Tu estación de radio ya es parte de ChatMurcianys.<br>Una página web ha sido creado para que puedas compartirla con tu audiencia",
    errorStreamCopy:
      "Esta transmisión de radio ya existe en nuestra aplicación. Por favor proporciona uno diferente.",
    uploadingLogo: "Subiendo logo...",
    uploadingBanner: "Subiendo el banner...",
    errorUnknown: "Hubo un error desconocido. Intenta nuevamente más tarde",
    uploadingRadioInfo: "Subiendo la información de la radio, por favor espera",
    errorImage: "No tienes permiso de subir la imagen.",
    errorUploadCancel: "Has cancelado la carga",
    downloadMess:
      "ChatMurcianys está disponible para tu dispositivo en Google PlayStore",
    download: "Descargar",
    idiom: "Es",
    urlCheck:
      "¿Puedes escuchar la radio? Si no, edita la transmisión de arriba",
    audioError:
      '*Algunos navegadores tal vez no reproducirán el audio porque no comienza con "https" <a id="aRadioLink" href="" target="_blank">Haz click aquí para probar el audio</a>',
    errorNameCopy:
      "Este nombre de radio ya existe en nuestra aplicación. Por favor proporciona uno diferente.",
    msgRadioVerify:
      "Hemos recibido tu solicitud para agregar $name a ChatMurcianys.<br>" +
      "Te notificaremos cuando tu radio esté registrada y lista para compartir.<br>" +
      'Mientras tanto, puedes verificar el estado de tu solicitud visitando "Mis radios" y hacer cualquier cambio necesario.',
    close: "Cerrar",
    errorStoragePermission:
      "No tienes permiso de subir esta imagen. Sube una imagen diferente",
    errorUploadCanceled: "La carga fue cancelada",
    errorProvideName: "Por favor provee tu nombre",
  },
};

function translatePage(lang) {
  var translate = false;
  if (lang) {
    translate = true;
    if (lang.includes("es")) {
      trans = language.es;
      document.getElementsByTagName("html")[0].setAttribute("lang", "es");
      aEn.className = aEn.className.replace(" set", "");
      aEs.className += " set";
      setCookie("lang", "es", 365);
    } else {
      trans = language.eng;
      document.getElementsByTagName("html")[0].setAttribute("lang", "en");
      aEs.className = aEn.className.replace(" set", "");
      aEn.className += " set";
      setCookie("lang", "en", 365);
    }
  } else if (getCookie("lang") != "") {
    if (getCookie("lang").includes("es")) {
      trans = language.es;
      document.getElementsByTagName("html")[0].setAttribute("lang", "es");
      var langs = langDropdown.querySelectorAll("a");
      langs[0].className = langs[0].className.replace(" set", "");
      langs[1].className += " set";
      translate = true;
      setCookie("lang", "es", 365);
    } else {
      trans = language.eng;
    }
  } else if (
    window.navigator.language &&
    window.navigator.language.includes("es")
  ) {
    translate = true;
    trans = language.es;
    document.getElementsByTagName("html")[0].setAttribute("lang", "es");
    aEn.className = aEn.className.replace(" set", "");
    aEs.className += " set";
  } else {
    trans = language.eng;
  }

  if (translate) {
    menuLang.textContent = trans.idiom;
    topHead.querySelector("h1").textContent = trans.title;
    //btnTranslate.textContent = trans.en;
    var registerPs = registerUser.querySelectorAll("p");
    registerPs[0].textContent = trans.register;
    registerPs[1].textContent = trans.continue;
    registerPs[2].textContent = trans.infoLog;
    registerPs[3].innerHTML = trans.disclaimer;
    btnPhoneLogin.textContent = trans.phone;
    btnEmailLogin.textContent = trans.email;
    etEmail.placeholder = trans.email;
    etPassword.placeholder = trans.password;
    btnLogin.textContent = trans.login;
    registerUser.querySelector(".boldText").textContent = trans.rememberMe;
    var radioPs = registerRadio.querySelectorAll("p");
    radioPs[3].textContent = trans.fillInfo;
    radioPs[4].textContent = trans.optionalInfo;
    radioPs[5].innerHTML = trans.disclaimer;
    var imgs = registerRadio.querySelectorAll(".uploadImage");
    imgs[0].textContent = trans.uploadBanner;
    imgs[1].textContent = trans.uploadLogo;
    inAdminName.placeholder = trans.adminName;
    inRadioName.placeholder = trans.radioName;
    inSlogan.placeholder = trans.slogan;
    inRadioStream.placeholder = trans.radioStream;
    inPassword.placeholder = trans.anyPass;
    var notes = registerRadio.querySelectorAll(".notes");
    notes[0].textContent = trans.noteSlogan;
    notes[1].textContent = trans.noteStream;
    notes[2].textContent = trans.notePass;
    inDescription.placeholder = trans.description;
    registerRadio.querySelector(".pickCountry label").textContent =
      trans.location;
    var country = countries.querySelectorAll("option");
    country[0].textContent = trans.country;
    inPhone.placeholder = trans.phone;
    inRadioEmail.placeholder = trans.email;
    inWebsite.placeholder = trans.website;
    btnAddRadio.textContent = trans.title;
    btnNext.textContent = trans.next;
    btnContinue.textContent = trans.next;
    if (newUser) {
      divPassInfo.textContent = trans.createPass;
    } else {
      divPassInfo.textContent = trans.welcomeBack;
    }
    loadingInfo.querySelector("p").textContent = trans.creatingAcc;
    registerModal.querySelector(".blueText").textContent = trans.whatName;
    registerModal.querySelector("span").textContent = trans.uploadImage;
    btnRegister.textContent = trans.registerMe;
    inName.placeholder = trans.name;
    loadingRadioRegister.querySelector("p").textContent = trans.radioRegister;
    modRegSuccess.querySelector("h2").textContent = trans.congrats;
    modRegSuccess.querySelector("p").innerHTML = trans.radioMessage;
    downloadApp.querySelector("#modalMessage2").textContent =
      trans.downloadMess;
    downloadApp.querySelector(".btnBlue").textContent = trans.download;
    divCheck.textContent = trans.urlCheck;
    registerRadio.querySelector(".notes.redText").innerHTML = trans.audioError;
    aRadioLink.href = inRadioStream.value.trim();
    $(".t-close").attr("title", trans.close);
  }
}
